// Working, Pixels interface change
import { useList } from "@refinedev/core";
import React, { ReactElement } from "react";
import { Canvas } from "types/canvas";
import { Shape } from "types/shape";

type DisplayCanvasProps = {
  canvas: Canvas;
  children: (pixels: Shape[] | undefined, isLoading: boolean) => JSX.Element;
};

export const DisplayCanvas: React.FC<DisplayCanvasProps> = ({
  canvas: { id },
  children,
}) => {
  const { data, isLoading } = useList<Shape>({
    resource: "shapes",
    liveMode: "auto",
    meta: {
      select: "*",
    },
    filters: [
      {
        field: "canvas_id",
        operator: "eq",
        value: id,
      },
    ],
    sorters: [
      {
        field: "created_at",
        order: "desc",
      },
    ],
    pagination: {
      mode: "off",
    },
  });

  const shapes = data?.data;

  return <>{children(shapes, isLoading)}</>;
};
